import { Button } from "~/components/ui/button";
import { claimCtaClassName } from "~/hec/components/molecules/claim-card/claim-cta-class";
import { cn } from "~/lib/ui";

import type { SignInCtaProps } from "./types";

/**
 * Molecule: a button-shaped link that opens the global account drawer.
 * `#login` is the drawer's hash contract (`account-drawer.tsx`); `/login`
 * itself only redirects to `/account`, so it is never linked here.
 */
export function SignInCta({
  label,
  redirectTo,
  variant = "cta",
  className,
  ...rest
}: SignInCtaProps) {
  const href = redirectTo
    ? `#login?redirectTo=${encodeURIComponent(redirectTo)}`
    : "#login";
  return (
    <Button
      asChild
      variant={variant}
      size="fit"
      className={cn(claimCtaClassName, className)}
    >
      <a href={href} {...rest}>
        {label}
      </a>
    </Button>
  );
}
